import { motionDurationExtraFast, motionDurationFast, motionDurationNormal, motionDurationSlow, motionDurationExtraSlow, motionDurationUltraSlow } from '@resultadosdigitais/tangram-design-tokens';
export const KINDS = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  HELP: 'help'
};
export const SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
};
export const placements = {
  in: 'in',
  out: 'out'
};
/**
 * Used to position content usually text
 */

export const alignments = {
  left: 'left',
  center: 'center',
  right: 'right',
  dynamic: 'dynamic'
};
/**
 * Used to position objects
 */

export const positions = {
  top: 'top',
  topStart: 'top-start',
  topEnd: 'top-end',
  bottom: 'bottom',
  bottomStart: 'bottom-start',
  bottomEnd: 'bottom-end',
  left: 'left',
  leftStart: 'left-start',
  leftEnd: 'left-end',
  right: 'right',
  rightStart: 'right-start',
  rightEnd: 'right-end'
};
export const modes = {
  light: 'light',
  dark: 'dark'
};
export const orientation = {
  ascending: 'ascending',
  descending: 'descending'
};
export const directions = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
export const viewports = {
  smallMobile: 'smallMobile',
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
  largeDesktop: 'largeDesktop'
};
export const durations = {
  extraFast: motionDurationExtraFast,
  fast: motionDurationFast,
  normal: motionDurationNormal,
  slow: motionDurationSlow,
  extraSlow: motionDurationExtraSlow,
  ultraSlow: motionDurationUltraSlow
};
export const shapes = {
  rectangle: 'rectangle',
  circle: 'circle',
  text: 'text'
};